export const isProduction = () => {
    return process.env.VUE_APP_HOST === 'production';
}
